import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import type {
	StartAPetitionAsyncPetitionDataQuery,
	StartAPetitionAsyncPetitionDataQueryVariables,
} from './api.graphql';
import { StartAPetitionAsyncPetitionData } from './api.graphql';

type Petition = NonNullable<StartAPetitionAsyncPetitionDataQuery['petition']>;
type QualityScore = Omit<Extract<NonNullable<Petition['qualityScore']>, { __typename: 'QualityScore' }>, '__typename'>;
type WithQualityScore = Readonly<{ qualityScore: QualityScore }>;

// Union of all possible return types
type StartAPetitionAsyncPetitionDataResponse = WithQualityScore;

type GetAsyncPetitionDataParams = {
	petitionId: string;
	fetchQualityScore: boolean;
};

export async function getAsyncPetitionData(
	{ petitionId, fetchQualityScore }: GetAsyncPetitionDataParams,
	{ gql: { fetch } }: UtilityContext,
): Promise<StartAPetitionAsyncPetitionDataResponse | undefined> {
	try {
		const { data } = await fetch<StartAPetitionAsyncPetitionDataQuery, StartAPetitionAsyncPetitionDataQueryVariables>({
			query: StartAPetitionAsyncPetitionData,
			variables: { slugOrId: petitionId, fetchQualityScore },
			rejectOnError: false,
		});

		const qualityScore =
			data?.petition?.qualityScore?.__typename === 'QualityScore' ? data.petition.qualityScore : undefined;

		if (fetchQualityScore && qualityScore)
			return { qualityScore: { totalScore: qualityScore.totalScore, categories: qualityScore.categories } };

		return undefined;
	} catch {
		// do nothing, we don't care if this fails
		return undefined;
	}
}
